
import store from '../../store'

export default {
    "title": "Landing Page",
    "entityName": "landingpage",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    filterStorage: {},
    "fields": [

        {
            md:6,
            "value": "title",
            "text": "Titolo",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
        },


        {
            md:6,
            "value": "template_id",
            "text": "Template",
            "title": "name",
            "type": "autocomplete",
            // "readonly": item => { return item.id ? true : false },
            // "return_object": true,
            "validators": [
                "required",
            ],
            readonly: (item) => {
                return item.template_id ? true : false
            },
            filter: (item, search) => {
                let searchObj = {'tag':"%Landing Page%"}
                if(search) {
                    searchObj['name'] = `%${search}%`
                }
                return searchObj
            }
            // render: (item) => {
            //     return item.country.name + " (" + item.country.code + ")" 
            // },
        },

        {
            md:6,
            "value": "url",
            "text": "Url",
            "type": "text",
            // "readonly": item => { return item.id ? true : false },
            // "return_object": true,
            "appendIcon": "mdi-link",
            "validators": [
                'required'
            ],
            clickAppend: (field, item) => {
                // console.log(field, item)
                window.open(store.getters.siteUrl + '/landing/' + item.url, '_blank')
            }
            // render: (item) => {
            //     return item.country.name + " (" + item.country.code + ")" 
            // },
        },


        {
            full: true,
            "value": "datamap",
            "text": "Datamap",
            "title": "name",
            "type": "component",
            "name": "cms-datamap",
            "bind" : (field) => {
                return { 
                  entity: "landing_page",
                  entityId: field.item.id,
                  clearDatamap:false
                }
              },
            // deps:['template_id'],
            // visible: (item) => {
            //     return item.template_id 
            // },
            // default: (item, args, selectedItem, state) => {
            //     console.log(item,  args, selectedItem, state)
            //     if(item.template_id) {
            //         return item.template && item.template.variablesFromTemplate
            //     }
            // }
            // "readonly": item => { return item.id ? true : false },
            // "return_object": true,
            // render: (item) => {
            //     return item.country.name + " (" + item.country.code + ")" 
            // },
        },




    ],
    "actions": [
        { "value": "update", "text": "Edit", "icon": "mdi-pencil", "color": "primary", 
    }
    ]
}